// being used
export const exportCSV = (
  ppeRecords,
  complianceData,
  formatCreatedAtDate,
  strict
) => {
  const staticHeaders = [
    "Observer",
    "Facility",
    "Unit",
    "Collection Date",
    "Precautions",
    "HCW Type",
    "Compliance",
    "Audit Strict Compliance",
  ];

  const dynamicHeaders =
    ppeRecords.length > 0
      ? ppeRecords[0].formQuestions.flatMap((section, sectionIndex) =>
          section.questions.map(
            (_, questionIndex) => `OP${sectionIndex + 1}-${questionIndex + 1}`
          )
        )
      : [];

  const headers = [...staticHeaders, ...dynamicHeaders];

  const csvRows = [];
  csvRows.push(headers.join(","));

  ppeRecords.forEach((record, recordIndex) => {
    const staticData = [
      record.nurse,
      record.facility,
      record.unit,
      `"${formatCreatedAtDate(record.createdAt)}"`,
      record.precautions,
      record.healthCareWorker,
      `${complianceData[recordIndex].numericValue}%`,
      record.auditStrictCompliance.toString(),
    ];

    const dynamicData = record.formQuestions.flatMap((section) =>
      section.questions.map((q) => `"${q.response.value}"`)
    );

    csvRows.push([...staticData, ...dynamicData].join(","));
  });

  const csvString = csvRows.join("\n");

  const blob = new Blob([csvString], { type: "text/csv" });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `PPE_Records_${new Date().toISOString()}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
